import React from 'react';
import { Component } from '@poa/core';
import { observable, action, computed, Observer } from '@poa/state';
import Collapsible from 'react-collapsible';

import Navbar from '../components/navbar';
import RouteLoading from '../components/route-loading';
import TableFilter from '../components/table-filter';

class ClientsPage extends React.Component {
  env; // injected by Poa
  syncRef;

  localState = observable({
    items: { data: {}, meta: { hasError: false, loaded: false } },
    panels: [],
    selectedPanel: null,
    sync: { status: 'complete', progress: 0 }
  });

  async componentDidMount() {
    try {
      await this.fetchSyncStatus();
      await this.fetchPanels();
      this.startPeriodicStatusSync();
    } catch (e) {
      console.error(e);
    } finally {
      this.fetchItems();
    }
  }

  componentWillMount() {
    this.stopPeriodicStatusSync();
  }

  fetchPanels = async () => {
    const response = await this.env.http.get('panels');
    this.localState.panels = response.data;
  };

  fetchItems = () => {
    this.env.http
      .get('clients')
      .then(
        action(({ data }) => {
          this.localState.items.meta.hasError = false;
          this.localState.items.meta.loaded = true;
          this.localState.items.data = data;
        })
      )
      .catch(
        action(error => {
          console.error(error);
          this.localState.items.meta.hasError = true;
          this.localState.items.meta.loaded = false;
        })
      );
  };

  startSync = async () => {
    this.localState.sync.progress = 'inprogress';

    try {
      let response;

      if (this.localState.selectedPanel) {
        response = await this.env.http.get(`clients/sync/${this.localState.selectedPanel}`);
      } else {
        response = await this.env.http.get('clients/sync/');
      }

      this.localState.sync.progress = response.data.progress;
      this.localState.sync.status = response.data.status;

      this.startPeriodicStatusSync();
    } catch (e) {
      this.env.alert('Ошибка', `Ошибка при старте синхронизации`, 'error');
    }
  };

  startPeriodicStatusSync = () => {
    if (!this.canSync.get()) {
      this.syncRef = setInterval(this.fetchSyncStatus, 5000);
    }
  };

  stopPeriodicStatusSync = () => clearInterval(this.syncRef);

  fetchSyncStatus = async () => {
    const response = await this.env.http.get('clients/status/');

    this.localState.sync.progress = response.data.progress;
    this.localState.sync.status = response.data.status;

    if (this.canSync.get()) {
      this.stopPeriodicStatusSync();
      this.localState.sync.progress = 0;
    }
  };

  canSync = computed(() => this.localState.sync.status === 'complete');

  render() {
    // TODO: fix key warning
    return (
      <RouteLoading meta={this.localState.items.meta}>
        <div className="content">
          <Navbar />

          <div className='under-navbar-content'>
            <TableFilter
              withoutFractionalChange
              withoutDatesChange
              withoutStatusChange
              withoutGroupingChange
              withoutFilteringChange
              render={() => (
                <Observer>
                  {() =>
                    this.canSync.get() ? (
                      <div className="filter" style={{ verticalAlign: 'middle', display: 'flex' }}>
                        <button
                          type="button"
                          className="filter-columns__save"
                          onClick={this.startSync}
                        >
                          Синхронизировать
                        </button>
                        <select
                          value={this.localState.selectedPanel}
                          onChange={({ currentTarget }) =>
                            (this.localState.selectedPanel = currentTarget.value)
                          }
                        >
                          <option value={null}>Все</option>
                          {this.localState.panels.map(panel => (
                            <option value={panel}>{panel}</option>
                          ))}
                        </select>
                      </div>
                    ) : (
                      <div className="filter" style={{ verticalAlign: 'middle' }}>
                        <button
                          disabled={true}
                          type="button"
                          className="filter-columns__save disabled"
                        >
                          Идет синхронизация ({this.localState.sync.progress}%)
                        </button>
                      </div>
                    )
                  }
                </Observer>
              )}
              withSearch={false}
              withColumnsConfigure={false}
              onAdd={this.onAddNew}
              getTableNode={() => this.node}
            />
            <div className="container">
              <div className="inner">
                <div className="inner-scroll unread-letters-table">
                  {Object.keys(this.localState.items.data).map((key, index) => {
                    return (
                      <div style={{ paddingBottom: '15px' }} key={index}>
                        <div>
                          <b>{key}</b>
                          <hr />
                        </div>
                        {this.localState.items.data[key].map((items, idx) => {
                          return Object.keys(items).map(key => {
                            return (
                              <Collapsible
                                key={`${index}-${idx}-${key}`}
                                trigger={key}
                                transitionTime={100}
                              >
                                {items[key].map((items, idxxx) => {
                                  return (
                                    <ul key={`${index}-${idx}-${key}-${idxxx}`}>
                                      {Object.keys(items).map((newKey, idxx) => {
                                        return (
                                          <li key={`${index}-${idx}-${key}-${newKey}-${idxx}`}>
                                            <a
                                              target="_blank"
                                              rel="noopener noreferrer"
                                              href={items[newKey]}
                                            >
                                              {newKey}
                                            </a>
                                          </li>
                                        );
                                      })}
                                    </ul>
                                  );
                                })}
                              </Collapsible>
                            );
                          });
                        })}
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </RouteLoading>
    );
  }
}

export default Component({ namespaces: ['clientsList'] })(ClientsPage);
